// extracted by extract-css-chunks-webpack-plugin
module.exports = {"page":"page_1p3vO","page_item":"page_item_3svyF","page_label":"page_label_1Cz7I","page_img":"page_img_24032","page_title":"page_title_11Fle"};